<form autocomplete="nope" class="material" #form="ngForm">
    <!-- File Upload -->
    <ng-container *ngIf="!employeeDocument?.id">
        <app-file-drop
            (filesSelected)="onFileSelected($event)"
            *ngIf="!file"
            [allowedTypes]="['.pdf']"
            [required]="true"
        ></app-file-drop>
        <div class="field" *ngIf="file">
            <label
                >{{ file.name }}
                <img (click)="onFileRemoved()" style="float: right" appIcon="CrossGreyUiOutline" />
            </label>
        </div>
    </ng-container>

    <mat-form-field class="w-100">
        <mat-label>{{ 'forms.employee-document.documentName' | translate }}</mat-label>
        <input
            type="text"
            required
            name="documentName"
            [(ngModel)]="employeeDocument.name"
            #docName="ngModel"
            matInput
        />
    </mat-form-field>

    <ui-chips-autocomplete
        #rolesAutocomplete
        *ngIf="!isSelfUpload || isAdmin"
        [label]="rolesLabel"
        [autocompleteItems]="roles"
        [selectedItems]="initialRoles"
    ></ui-chips-autocomplete>
</form>
